import {GmailController} from '../../hooks/useGmailConnection';
import {Btn, Spinner} from '../Shared';
import {Dialog, DialogContent, DialogTitle, DialogDescription} from '../ui/dialog';

export const DisconnectDialog = ({connection}: {connection: GmailController}) => <Dialog open={connection.disconnectOpen} onOpenChange={connection.setDisconnectOpen}>
  <DialogContent className="app-modal" data-testid="gmail-disconnect-modal">
    <DialogTitle data-testid="gmail-disconnect-title">Disconnect Gmail?</DialogTitle>
    <DialogDescription data-description="true" data-testid="gmail-disconnect-description">Automatic sync will stop. Your existing tickets and drafts will stay in this workspace.</DialogDescription>
    <div className="form-footer"><Btn data-testid="gmail-disconnect-cancel" onClick={() => connection.setDisconnectOpen(false)}>Keep connected</Btn>
      <Btn className="danger-button" disabled={Boolean(connection.busy)} onClick={connection.disconnect} data-testid="gmail-disconnect-confirm">{connection.busy && <Spinner/>}Disconnect</Btn>
    </div>
  </DialogContent>
</Dialog>;